
import Steps from './Steps';
import { STEP_MODEL } from '../Model/Model';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const StepContainer = (
    {
        guardFlowId,
        activeStep,
        setActiveStep,

        facePhoto, setFacePhoto,
        passport, setPassport,
        idCardFront, setIdCardFront,
        idCardBack, setIdCardBack,

        handleSaveFaceValidation,
        handleSavePassport,
        handleSaveCardId,

        t,
        type,
        loading,
        nextPhoto,
        startup, setStartup,
        reopenSuggestionShow, setReopenSuggestionShow,
        stepModel,

        handleCancelStreamCardId,
        handleCancelStreamPassport,
        handleCancelStreamSelfie
    }
) => {
    const { renderFaceSteps, renderFilesSteps, renderCompleteSteps }
        = Steps({
            guardFlowId,
            activeStep,
            setActiveStep,

            facePhoto, setFacePhoto,
            passport, setPassport,
            idCardFront, setIdCardFront,
            idCardBack, setIdCardBack,

            handleSaveFaceValidation,
            handleSavePassport,
            handleSaveCardId,

            t,
            type,
            loading,
            nextPhoto,
            startup, setStartup,
            reopenSuggestionShow,
            setReopenSuggestionShow,

            handleCancelStreamCardId,
            handleCancelStreamPassport,
            handleCancelStreamSelfie
        }
        );

    const renderStepContent = () => {
        switch (stepModel?.NAME) {
            case STEP_MODEL.COMPLETE.NAME:
                return renderCompleteSteps();
            case STEP_MODEL.FILES.NAME:
                return renderFilesSteps();
            case STEP_MODEL.FACE.NAME:
                return renderFaceSteps();
            default:
                return null;
        }
    };

    return <>{renderStepContent()}</>;
};

export default StepContainer
